<template>
  <div class="services_layer">
    <div class="background"></div>
    <div class="background"></div>
    <div class="background"></div>
    <div class="background last"></div>
    <div class="page_1 align_center">
      <div class="contents_wrapper">
        <div class="limited_width_box">
          <div class="title main">
            <span class="text nowrap">Fully</span>
            <span class="text nowrap">Customized</span>
            <span class="text nowrap">Control</span>
            <span class="text nowrap">System</span>
          </div>
          <div class="description main one effect_line">
            <span class="text">
              It is a <span class="dark_sky__">Fully Customizable Management System Development Service</span> for perfect project control. 
              We focus on the uniqueness of each project and work and offer many of the featured 
              functionalities to satisfy the needs of site requirements. Also, it has the capability 
              of collaborating between Engineering Company and Fabricator to serve better data control.
            </span>
            <span class="line"></span>
          </div>
          <div class="section_wrapper balanced">
            <div class="section service_features">
              <div class="title">
                Service Features
              </div>
              <div class="description font_extendalble_2">
                <ul>
                  <li>Custom-fitted Controlling Solution</li>
                  <li>User Friendly Interface</li>
                  <li>Collaboration of Company, Fabricator, and Contractor</li>
                  <li>Focus Managing on Construction Site</li>
                </ul>
              </div>
            </div>
            <div class="section benefits">
              <div class="title">
                Benefits
              </div>
              <div class="description font_extendalble_2">
                <ul>
                  <li>Increase Productivity and Efficiency</li>
                  <li>Reducing Time to Manage a Work</li>
                  <li>Easy Document & Report Sharing with Any Team Members</li>
                  <li>Cost Effectiveness</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="description main margin_5 two">
            So, what's the customizable management system? All types of the system below have been implemented
            into the <span class="dark_sky__">JinSolutions</span>, and it provides the <span class="dark_sky__">Integrated Project 
            Management Service</span> like never before.
          </div>
          <div class="section_wrapper balanced">
            <div class="section one">
              <div class="title gap">
                <span class="marker">
                  <ul>
                    <li>
                      One
                    </li>
                  </ul>
                </span>
                <span>Site</span> <span>Business</span> <span>Management</span> <span>System</span>
              </div>
              <div class="description font_extendalble_2">
                <ul>
                  <li>Visitor & Travelers Log</li>
                  <li>Resident Log</li>
                  <li>Site Member List</li>
                  <li>Office Lay-out</li>
                  <li>Office W/O Control</li>
                  <li>Time Sheet Control</li>
                </ul>
              </div>
            </div>
            <div class="section two">
              <div class="title gap">
                <span class="marker">
                  <ul>
                    <li>
                      Two
                    </li>
                  </ul>
                </span>
                <span>Documents</span> <span>Control</span> <span>System</span>
              </div>
              <div class="description font_extendalble_2">
                <ul>
                  <li>Master Document Register</li>
                  <li>Engineering Data</li>
                  <li>Vendor Data</li>
                  <li>Shop Drawing</li>
                  <li>Site Queries (FPDs / FTQs / SIQs / etc.)</li>
                  <li>Change Order Control</li>
                </ul>
              </div>
            </div>
            <div class="section three">
              <div class="title gap">
                <span class="marker">
                  <ul>
                    <li>
                      Three
                    </li>
                  </ul>
                </span>
                <span>Procurement</span> <span>& Inventory</span> <span>Control</span> <span>System</span>
              </div>
              <div class="description font_extendalble_2">
                <ul>
                  <li>PO and PND Control</li>
                  <li>Warehouse Inventory Control</li>
                  <li>Preservation Activity</li>
                  <li>Commissioning Spare Part Inventory Control</li>
                </ul>
              </div>
            </div>
            <div class="section four">
              <div class="title gap">
                <span class="marker">
                  <ul>
                    <li>
                      Four
                    </li>
                  </ul>
                </span>
                <span>Construction</span> <span>Control</span> <span>System</span>
              </div>
              <div class="description font_extendalble_2">
                <ul>
                  <li>Commissioning Spare Part Inventory Control</li>
                  <li>Construction Punch Control</li>
                </ul>
              </div>
            </div>
            <div class="section five">
              <div class="title gap">
                <span class="marker">
                  <ul>
                    <li>
                      Five
                    </li>
                  </ul>
                </span>
                <span>Project</span> <span>Completion</span> <span>System</span>
              </div>
              <div class="description font_extendalble_2">
                <ul>
                  <li>Commissioning Punch Control</li>
                  <li>Integrated HUC Management System (Job Card)</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page_2 align_center">
      <div class="contents_wrapper">
        <div class="limited_width_box">
          <div class="title main">
            <span class="text nowrap">Integrated</span>
            <span class="text nowrap">Project</span>
            <span class="text nowrap">Management</span>
            <span class="text nowrap">Service</span>
          </div>
          <div class="description main text_line_end">
            It is powerful tools that enables managers to easily access related project data and reports,
            and make and execute planning ahead of time. Also, this service seeks to establish an integrated 
            engineering environment so that different department or discipline lead group at construction 
            site can work cohesively and collaborate more effectively using a single platform system.
          </div>
          <div class="section_wrapper">
            <div class="section service_features">
              <div class="title">
                Service Features
              </div>
              <div class="description font_extendalble_2">
                <ul>
                  <li>Analyzing and processing raw data precisely and accurately by our data analysis specialist</li>
                  <li>Controlling data and information through robust web server</li>
                  <li>Enhancing data integration throughout discipline lead, fabricator, and contractor</li>
                  <li>Simplifying project monitoring just with a few clicks on the project website</li>
                  <li>Downloading any documents and processed files easily with a few clicks</li>
                  <li>Providing powerful and intelligent report service of overall progress status by weekly</li>
                </ul>
              </div>
            </div>
            <div class="section benefits">
              <div class="title">
                Benefits
              </div>
              <div class="description font_extendalble_2">
                <ul>
                  <li>Increase Productivity and Efficiency</li>
                  <li>Cost Effectiveness</li>
                  <li>Enhance Teamwork</li>
                  <li>Save Time for all Project Members</li>
                  <li>Better Decision Making</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="section_wrapper">
            <div class="section works">
              <div class="title">
                How it works?
              </div>
              <div class="description font_extendalble_2">
                For successfully managing a project, it is crucial to have usable information to make accurate decisions. 
                Without technical background, it is very labor intensive work to process the tremendous raw data and turn 
                it to valuable information. JinGraphics is helping project managers by processing huge raw data very 
                effectively, professionally, and promptly with establishing a database which generate beneficial information. 
                Below procedure guides a client to understand how our service is started, provided, and used.
              </div>
            </div>
          </div>
          <div class="section_wrapper balanced">
            <div class="section procedure">
              <div class="title">
                Work Procedure
              </div>
              <div class="description image_wrapper">
                <object :data="require('@/assets/images/procedure.svg')" width="100%"></object>
              </div>
            </div>
            <div class="section procedure">
              <div class="title">
                Scope Of Service
              </div>
              <div class="description image_wrapper">
                <object :data="require('@/assets/images/scope.svg')" width="100%"></object>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { ScrollMixin } from '@/mixins/scroll.mixin'

export default {
  name: 'services',
  mixins: [
    ScrollMixin
  ],
  computed: {
    ...mapState(['scale']),
  },
  mounted() {
    this.init()
    this.$emit('mounted', 'services')
  },
  methods: {
    init() {
      let ts = document.querySelectorAll('.services_layer .title.main span')
      ts.forEach(t => {
        t.innerHTML = t.textContent.replace(/\S/g, "<span class='letter' style='display: inline-block;'>$&</span>")
      })

      this.setScrollAnime([
        { 
          targets: [
            { name: '.services_layer .page_1 .title.main', items: '.services_layer .page_1 .title.main span', status: 'opened' },
            { name: '.services_layer .page_2 .title.main', items: '.services_layer .page_2 .title.main span', status: 'closed' },
          ], 
          in: {
            translateX: [40, 0],
            translateZ: 0,
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 750,
            delay: (el, i) => 15 * i
          },
          out: {
            translateX: [0, -40],
            translateZ: 0,
            opacity: [1, 0],
            easing: "easeOutExpo",
            duration: 750,
            delay: (el, i) => 15 * i
          }
        },
        { 
          targets: [
            { name: '.services_layer .page_1 .description.one', status: 'opened' },
            { name: '.services_layer .page_1 .section_wrapper .service_features', status: 'closed' },
            { name: '.services_layer .page_1 .section_wrapper .benefits', status: 'closed' },
            { name: '.services_layer .page_1 .description.two', status: 'closed' },
            { name: '.services_layer .page_1 .section.one', status: 'closed' },
            { name: '.services_layer .page_1 .section.two', status: 'closed' },
            { name: '.services_layer .page_1 .section.three', status: 'closed' },
            { name: '.services_layer .page_1 .section.four', status: 'closed' },
            { name: '.services_layer .page_1 .section.five', status: 'closed' },

            { name: '.services_layer .page_2 .description.main', status: 'closed' },
            { name: '.services_layer .page_2 .section_wrapper .service_features', status: 'closed' },
            { name: '.services_layer .page_2 .section_wrapper .benefits', status: 'closed' },
            { name: '.services_layer .page_2 .section_wrapper .works', status: 'closed' },
          ], 
          in: {
            translateX: [100, 0],
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 2500
          },
          out: {
            translateX: -300,
            opacity: 0,
            easing: "easeOutExpo",
            duration: 2500
          }
        },
      ])
    },
    open() {
      let w = window.outerWidth
      let dgs = document.querySelectorAll('.services_layer .background').length
      let dgWidth = 5

      this.$anime.timeline({loop: false})
      .add({
        targets: '.services_layer .background',
        left: (el, i) => [w, i * dgWidth],
        duration: 1000,
        delay: (el, i) => 75 * i
      })
      .add({
        targets: '.services_layer .background.last',
        width: [dgWidth, w - (dgs-1) * dgWidth],
        easing: "easeOutExpo",
        duration: 500,
      })
      .add({
        targets: '.services_layer .background',
        opacity: 0,
        easing: "easeOutExpo",
        duration: 10000
      })

      this.$anime({
        targets: '.services_layer .page_1 .title.main span',
        translateX: [40, 0],
        translateZ: 0,
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 1500,
        delay: (el, i) => 1250 + 30 * i
      })

      let elbox = document.querySelector('.services_layer .page_1 .description.one').getBoundingClientRect()
      // set scaled width
      w = parseInt(elbox.width / this.scale)
      this.$anime.timeline({loop: false})
      .add({
        targets: '.services_layer .page_1 .description.effect_line .line',
        scaleY: [0, 1],
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 500,
        delay: 1500
      })
      .add({
        targets: '.services_layer .page_1 .description.effect_line .line',
        translateX: [0, w],
        easing: "easeOutExpo",
        duration: 750,
        delay: 100
      })

      this.$anime({
        targets: '.services_layer .page_1 .description.effect_line .text',
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 1500,
        delay: 2350
      })

      this.openOverContents(2500, 150)
    },
    close() {
      window.scrollTo(0, 0)
      
      this.$anime({
        translateY: [0, -100],
        targets: '.services_layer',
        opacity: 0,
        easing: "easeOutExpo",
        duration: 500
      })
      setTimeout(() => {
        this.$emit('closed', 'services')
      }, 500)
    },
  }
}
</script>

<style lang="scss" scoped>
.services_layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;

  .background {
    position: fixed;
    top: 0;
    right: -35px;
    bottom: 0;

    width: 5px;
    background: rgba(0, 0, 0, .1);
  }

  .image_wrapper {
    padding: 3rem;
    border: .5rem solid rgba(0, 0, 0, .1);
    border-radius: 1rem;
    -moz-border-radius: 1rem;
    -webkit-border-radius: 1rem;

    background-color: rgba(255, 255, 255, .1);
    
  }
}
</style>